"use client";
import { FieldAction as e } from "../fields/FieldAction.js";
import { FieldFrame as t, fieldInputClass as n, fieldShellClass as r } from "../fields/FieldFrame.js";
import { useTextField as i } from "../fields/useTextField.js";
import { jsx as a, jsxs as o } from "react/jsx-runtime";
import s from "clsx";
import { forwardRef as c, useEffect as l, useState as u } from "react";
//#region src/components/input/Input.tsx
var d = c(function(c, d) {
	let f = i(c);
	l(() => {
		let e = f.controlRef.current;
		if (!e || c.type !== "number") return;
		let t = (t) => {
			document.activeElement === e && t.preventDefault();
		};
		return e.addEventListener("wheel", t, { passive: !1 }), () => {
			e.removeEventListener("wheel", t);
		};
	}, [f.controlRef, c.type]);
	let [p, m] = u(!1), { label: h, hideLabel: g, labelConfig: _, description: v, errorConfig: y, sourceConfig: b, disableConfig: x, value: S, defaultValue: C, onValueChange: w, leadingIcon: T, prefix: E, suffix: D, actionConfig: O, className: k, onBlur: A, ...j } = c, M = "pf:self-stretch pf:flex pf:items-center pf:px-md pf:bg-soft-pearl-200 pf:text-soft-pearl-800 pf:max-w-[30%] pf:truncate pf:shrink-0 pf:border-soft-pearl-400";
	return /* @__PURE__ */ a(t, {
		field: c,
		id: f.id,
		supportId: f.supportId,
		error: f.error,
		className: k,
		children: /* @__PURE__ */ o("div", {
			className: s(r, "pf:min-h-[28px] pf:text-label-13"),
			"data-invalid": f.error ? "" : void 0,
			"data-disabled": x?.isDisabled ? "" : void 0,
			children: [
				E && /* @__PURE__ */ a("span", {
					className: s(M, "pf:border-e pf:rounded-s-sm"),
					title: E,
					children: E
				}),
				/* @__PURE__ */ o("div", {
					className: "pf:flex pf:min-w-0 pf:flex-1 pf:items-center pf:gap-xs pf:px-md",
					children: [T && /* @__PURE__ */ a("span", {
						"aria-hidden": "true",
						className: "pf:flex pf:items-center pf:justify-center pf:shrink-0 pf:size-[16px] pf:[&>svg]:size-full",
						children: T
					}), /* @__PURE__ */ a("input", {
						...j,
						id: f.id,
						ref: (e) => {
							f.controlRef.current = e, typeof d == "function" ? d(e) : d && (d.current = e);
						},
						type: c.type === "password" && p ? "text" : c.type,
						value: f.value,
						disabled: x?.isDisabled,
						"aria-invalid": f.error ? !0 : j["aria-invalid"],
						"aria-describedby": f.describedBy,
						onChange: (e) => {
							f.change(e.target.value);
						},
						onBlur: (e) => {
							f.blur(), A?.(e);
						},
						className: s(n, "pf:text-label-13 pf:border-0 pf:p-0 pf:min-h-[26px]")
					})]
				}),
				D && /* @__PURE__ */ a("span", {
					className: s(M, "pf:border-s pf:rounded-e-sm"),
					title: D,
					children: D
				}),
				O && /* @__PURE__ */ a(e, {
					config: O,
					value: f.value,
					fieldLabel: c.label ?? c["aria-label"],
					revealed: p,
					disabled: O.kind === "clear" && (x?.isDisabled || c.readOnly || !f.value),
					onAction: () => {
						O.kind === "clear" ? f.change("") : m(!p), f.controlRef.current?.focus();
					}
				})
			]
		})
	});
});
//#endregion
export { d as Input };
